<template>
  <VueEditor
    :id="id"
    v-model="dataModel"
    :useCustomImageHandler="true"
    @image-added="handleImageAdded"
    class="fm-editor-container"
    :disabled="disabled"
  />
</template>

<script>
import { generateUUID, getCurDate } from '../../util/index.js'
import { config } from '../../config/config'
import alertUtils from '../../util/alertUtils'

export default {
  name: 'fm-editor',
  props: {
    value: {
      type: String,
      default: '',
    },
    sty: {
      type: Object,
      default: () => ({}),
    },
    toolbar: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueEditor: () =>
      new Promise(resolve => {
        import('vue2-editor').then(module => {
          resolve(module.default.VueEditor)
        })
      }),
  },
  data() {
    return {
      id: 'editor-' + generateUUID(),
      dataModel: this.value,
    }
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation) {
      const xhr = new XMLHttpRequest()
      const uploadApi = '/api/v1/file/service/file-upload/upload'
      const dir = getCurDate()
      const url =
        config.fileBaseAPI +
        uploadApi +
        '?appId=' +
        this.appId +
        '&dir=' +
        dir +
        '&fileType=' +
        ''
      xhr.open('POST', url, true)
      const token = localStorage.getItem('Admin-Token')
      xhr.setRequestHeader('X-Id-Token', token)
      const visitor = sessionStorage.getItem('visitor')
      xhr.setRequestHeader('visitor', visitor)
      const timeStr = Date.now()
      xhr.setRequestHeader('timeStr', timeStr)
      const formData = new FormData()
      formData.append('file', file)
      xhr.send(formData)
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const resData = JSON.parse(xhr.response)
          if (
            resData &&
            resData.status === 200 &&
            resData.data &&
            resData.data.id
          ) {
            const url =
              config.fileBaseAPI +
              '/api/v1/file/service/file-upload/view-img?id=' +
              resData.data.id
            Editor.insertEmbed(cursorLocation, 'image', url)
            alertUtils.alertSuccess('上传成功', true)
          } else {
            alertUtils.alertError('上传失败', true)
          }
        }
      }
    },
  },
  watch: {
    dataModel(val) {
      this.$emit('input', val)
      this.$emit('change')
    },
    value(val) {
      this.dataModel = val
    },
  },
}
</script>
